import { useRef, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Upload, Loader2, FileText } from "lucide-react";
import { resolveImage } from "@/lib/images";

const API = `${process.env.REACT_APP_BACKEND_URL || 'https://smapi.sanmartino26.al'}/api`;

export const FileField = ({ label, value, onChange, token, testid }) => {
  const fileRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const upload = async (file) => {
    if (!file) return;
    if (file.size > 8 * 1024 * 1024) {
      toast.error("Madhësia maksimale 8MB.");
      return;
    }
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await axios.post(`${API}/admin/upload`, fd, {
        headers: { Authorization: `Bearer ${token}` },
      });
      onChange(data.url);
      toast.success("Skedari u ngarkua.");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Gabim në ngarkim.");
    } finally {
      setBusy(false);
      if (fileRef.current) fileRef.current.value = "";
    }
  };

  return (
    <div className="space-y-2">
      <label className="block text-[0.65rem] tracking-[0.28em] uppercase text-sm-olive font-medium">
        {label}
      </label>
      <div className="flex flex-col md:flex-row gap-3 items-start">
        {value && (
          <div className="w-16 h-16 border border-sm-border flex items-center justify-center shrink-0 bg-sm-surface text-sm-olive">
            <FileText className="w-6 h-6" />
          </div>
        )}
        <div className="flex-1 w-full space-y-2">
          <input
            type="text"
            value={value || ""}
            onChange={(e) => onChange(e.target.value)}
            placeholder="https://... ose ngarko"
            className="sm-admin-input w-full"
            data-testid={testid ? `${testid}-url` : undefined}
          />
          <input
            ref={fileRef}
            type="file"
            accept=".pdf"
            className="hidden"
            onChange={(e) => upload(e.target.files?.[0])}
            data-testid={testid ? `${testid}-file` : undefined}
          />
          <button
            type="button"
            onClick={() => fileRef.current?.click()}
            disabled={busy}
            data-testid={testid ? `${testid}-upload-btn` : undefined}
            className="inline-flex items-center gap-2 border border-sm-border bg-sm-bg px-4 py-2 text-[0.7rem] tracking-[0.28em] uppercase font-medium hover:border-sm-olive transition-colors disabled:opacity-60"
          >
            {busy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <Upload className="w-3.5 h-3.5" />}
            {busy ? "Duke ngarkuar..." : "Ngarko skedar"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default FileField;
